export default __webpack_public_path__ + "static/media/short-logo-nobg.2447deb4.png";